import { FRONTEND_DATE_FORMAT } from '@symfa-inc/providence-types';
import { dateWorker } from '@core/utils/date-worker';
import { DateDateWorker } from '@models/types';

export const isExcludedValidationDate = (value?: DateDateWorker): boolean =>
  dateWorker(value).isSame(
    dateWorker('01/01/1950', FRONTEND_DATE_FORMAT),
    'day',
  );
